import React, { Component } from "react";
import { Link } from "react-router-dom";
import Information from "../Information";
import { Paths } from "../../../constants/UrlConstants";
import Store from "../../../content/Store";
import { getContentByVariationType } from "../../../content/ContentDoneSimply";

class TimeSettings extends Component {
  render() {
    var content = getContentByVariationType(
      Store.TimeSettingsContent.variationTypes.Any,
      Store.TimeSettingsContent
    );

    return (
      <Information headerText={content.headerText}>
        {content.message}
        <p>
          <Link to={Paths.HomeRoot}>
            {content.linkMessage}
            <span className="ml-2">➔</span>
          </Link>
        </p>
      </Information>
    );
  }
}

export default TimeSettings;
